module.exports = __webpack_public_path__ + "media/entities/1109-d0d69cdb.png";